export const apiFetch = async (url, options = {}) => {
    const token = localStorage.getItem("token");

    const headers = {
        ...(options.headers || {}),
    };

    // Add Content-Type header if body is present and not FormData
    if (options.body && !(options.body instanceof FormData)) {
        headers["Content-Type"] = "application/json";
    }

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const res = await fetch(url, {
        credentials: "include",
        ...options,
        headers,
    });

    return res;
};

/**
 * Helper function to parse API response (handles both JSON and text)
 */
export const parseApiResponse = async (response) => {
    const contentType = response.headers.get("content-type");

    // Try to parse as JSON if content-type is application/json
    if (contentType && contentType.includes("application/json")) {
        try {
            return await response.json();
        } catch (e) {
            // If JSON parsing fails, return text
            return await response.text();
        }
    }

    // Otherwise, parse as text
    return await response.text();
};
